// extracted by mini-css-extract-plugin
module.exports = {"desktop":"styles_desktop__ZgszD","background":"styles_background__iW7AD","shadow":"styles_shadow__m45iv","image":"styles_image__C9_ty","text":"styles_text__99qez"};